import React from 'react';
import {
  Layout,
  NewsLetterBar,
  UtilityMenuBanner,
} from '../v2/components/common';
import {
  BetterSection,
  BetterForEveryone,
  CaseStudies,
  TrustedByNames,
  ReadyToSee,
  BetterTexts,
  HeroHome,
  Hero,
} from '../v2/components/home-page';
import { usePageViewTracking } from '../utils/trackPageView';
import { useTreatmentWithAttr } from '../hooks/split';

const HomePage: React.FC = () => {
  usePageViewTracking('home');

  const heroTreatment = useTreatmentWithAttr('hover-static-home-hero-split');

  const renderHeroComponent = () => {
    if (heroTreatment === 'on') {
      return <Hero />;
    }
    return <HeroHome />;
  };

  return (
    <Layout
      title="Fully Measured, Customizable 3D Models"
      dividerColor="neutral.100"
      buttonType="SCHEDULE_A_DEMO"
      bannerElement={<UtilityMenuBanner />}
    >
      {renderHeroComponent()}
      <BetterForEveryone />
      <BetterTexts />
      <BetterSection />
      <CaseStudies />
      <TrustedByNames />
      <ReadyToSee />
      <NewsLetterBar />
    </Layout>
  );
};

export default HomePage;
